import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Modal } from '@/components/Modal';
import { HELP_BY_ID } from '@/content/help';

/** Botão "?" de ajuda contextual — abre o tópico da tela atual. */
export function HelpButton({ topic }: { topic: string }) {
  const [open, setOpen] = useState(false);
  const t = HELP_BY_ID[topic];
  if (!t) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={`ajuda: ${t.title}`}
        className="tap flex h-8 w-8 items-center justify-center rounded-full border border-slate-300 text-sm text-slate-500 hover:border-slate-900 hover:text-slate-900"
      >
        ?
      </button>
      <Modal open={open} title={`${t.icon} ${t.title}`} onClose={() => setOpen(false)} size="lg">
        <div className="flex flex-col gap-3">
          {t.body}
          <p className="mt-2 text-right text-sm">
            <Link
              to={`/help#${t.id}`}
              onClick={() => setOpen(false)}
              className="text-slate-500 underline-offset-2 hover:underline"
            >
              ver central de ajuda →
            </Link>
          </p>
        </div>
      </Modal>
    </>
  );
}
